// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updateActualAuditDate = date => ({
    auditDate: date,
    type: actions.UPDATE_TCSM_RECORD_AUDIT_ACTUAL_AUDIT_DATE
});

export const updateRecordAuditModalVisibility = visibility =>

    dispatch => {

        addRemoveModalClass(visibility);

        dispatch({
            type: actions.UPDATE_TCSM_RECORD_AUDIT_MODAL_VISIBILITY,
            visibility
        });

    };

export const updateRecordAuditResults = results => ({
    results,
    type: actions.UPDATE_TCSM_RECORD_AUDIT_RESULTS
});

export const updateRecordAuditFile = file => ({
    file,
    type: actions.UPDATE_TCSM_RECORD_AUDIT_FILE
});



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/action-creators/audit-recording.js